import { countries } from '@heidi/utils/countries';

const flagEmoji = (countryCode: string) =>
  String.fromCodePoint(
    ...[...countryCode.toUpperCase()].map((char) => 127397 + char.charCodeAt(0))
  );

const countryCodeByName = new Map(
  countries.flatMap((country) =>
    country.countryCode ? ([[country.name, country.countryCode]] as const) : []
  )
);

/** Combobox rows for the book-a-demo country field. Value is the HubSpot country name. */
export const HEIDI_2_BOOK_DEMO_COUNTRY_ITEMS = countries
  .filter((country): country is typeof country & { countryCode: string } =>
    Boolean(country.countryCode)
  )
  .map((country) => ({
    value: country.name,
    label: country.name,
    keywords: [country.countryCode],
    icon: (
      <span aria-hidden className="text-base leading-none">
        {flagEmoji(country.countryCode)}
      </span>
    ),
  }));

/** ISO 3166-1 alpha-2 for a HubSpot country name, or undefined if unknown. */
export const getHeidi2BookDemoCountryCode = (name: string | undefined) =>
  name ? countryCodeByName.get(name) : undefined;

export const Heidi2BookDemoCountryFlag = ({ name }: { name: string }) => {
  const countryCode = getHeidi2BookDemoCountryCode(name);
  if (!countryCode) return null;

  return (
    <span aria-hidden className="text-base leading-none">
      {flagEmoji(countryCode)}
    </span>
  );
};
